var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMail = function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 3.063a.439.439 0 0 0-.438.437v.604L6.03 7.976a1.53 1.53 0 0 0 1.944 0l4.715-3.872V3.5a.439.439 0 0 0-.438-.438H1.75Zm-.438 2.74V10.5c0 .24.197.438.438.438h10.5c.24 0 .438-.197.438-.438V5.802L8.805 8.991a2.844 2.844 0 0 1-3.61 0L1.312 5.802ZM0 3.5c0-.965.785-1.75 1.75-1.75h10.5c.965 0 1.75.785 1.75 1.75v7c0 .965-.785 1.75-1.75 1.75H1.75C.785 12.25 0 11.465 0 10.5v-7Z",
    fill: "#fff"
  })));
};
export default SvgMail;